import { render } from "./IntoComponent.vue?vue&type=template&id=d367bf08&scoped=true"
import script from "./IntoComponent.vue?vue&type=script&lang=js"
export * from "./IntoComponent.vue?vue&type=script&lang=js"

import "./IntoComponent.vue?vue&type=style&index=0&id=d367bf08&lang=scss&scoped=true"

import exportComponent from "C:\\www\\farming_chat_pc_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d367bf08"]])

export default __exports__